module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Select date":"Datum wählen","Reservations":"Reservierungen","Guests":"Gäste","Pending":"Ausstehend","Confirmed":"Bestätigt","Seated":"Platziert","Completed":"Abgeschlossen","Cancelled":"Storniert","Table":"Tisch"}}')
  delete Component.options._Ctor
}
